import { Col, Row } from "react-bootstrap";

export default function OneWayFareSummary({
  review,
  values,
  calculateSSRAmount,
}) {
  const userMarkUp = values?.userMarkup != null ? values?.userMarkup : 0;
  const adminMarkup = values?.adminMarkup != null ? values?.adminMarkup : 0;

  return (
    <div>
      <Row>
        <Col
          xs={6}
          md={6}
          lg={6}
          style={{
            fontSize: 15,
            fontWeight: "bold",
          }}
        >
          Base Fare
        </Col>
        <Col
          xs={6}
          md={6}
          lg={6}
          style={{ justifyContent: "flex-end", display: "flex" }}
        >
          {review?.tripInfos[0].totalPriceList.map((subItem, index) => {
            return (
              <Row key={index}>
                {subItem.fd.ADULT && (
                  <div>
                    <div
                      style={{
                        fontSize: 15,
                        fontWeight: "bold",
                        justifyContent: "flex-end",
                        display: "flex",
                      }}
                    >
                      Adult(s) ({review?.searchQuery.paxInfo.ADULT} x ₹{" "}
                      {Number(subItem.fd.ADULT?.fC?.BF).toFixed(2)})
                    </div>
                    <div
                      style={{
                        fontSize: 14,
                        justifyContent: "flex-end",
                        display: "flex",
                      }}
                    >
                      ₹{" "}
                      {Number(
                        subItem.fd.ADULT?.fC?.BF *
                          review?.searchQuery.paxInfo.ADULT
                      ).toFixed(2)}
                    </div>
                  </div>
                )}

                {subItem.fd.CHILD && (
                  <div>
                    <div
                      style={{
                        fontSize: 15,
                        fontWeight: "bold",
                        justifyContent: "flex-end",
                        display: "flex",
                      }}
                    >
                      Child(s) ({review?.searchQuery.paxInfo.CHILD} x ₹{" "}
                      {Number(subItem.fd.CHILD?.fC?.BF).toFixed(2)})
                    </div>
                    <div
                      style={{
                        fontSize: 14,
                        justifyContent: "flex-end",
                        display: "flex",
                      }}
                    >
                      ₹{" "}
                      {Number(
                        subItem.fd.CHILD?.fC?.BF *
                          review?.searchQuery.paxInfo.CHILD
                      ).toFixed(2)}
                    </div>
                  </div>
                )}
                {subItem.fd.INFANT && (
                  <div>
                    <div
                      style={{
                        fontSize: 15,
                        fontWeight: "bold",
                        justifyContent: "flex-end",
                        display: "flex",
                      }}
                    >
                      Infant(s) ({review?.searchQuery.paxInfo.INFANT} x ₹{" "}
                      {Number(subItem.fd.INFANT?.fC?.BF).toFixed(2)})
                    </div>
                    <div
                      style={{
                        fontSize: 14,
                        justifyContent: "flex-end",
                        display: "flex",
                      }}
                    >
                      ₹{" "}
                      {Number(
                        subItem.fd.INFANT?.fC?.BF *
                          review?.searchQuery.paxInfo.INFANT
                      ).toFixed(2)}
                    </div>
                  </div>
                )}
              </Row>
            );
          })}
        </Col>
        <Col
          xs={6}
          md={6}
          lg={6}
          style={{
            fontSize: 15,
            fontWeight: "bold",
          }}
        >
          Total Base Fare
        </Col>
        <Col
          xs={6}
          md={6}
          lg={6}
          style={{
            justifyContent: "flex-end",
            display: "flex",
            fontSize: 15,
            fontWeight: "bold",
          }}
        >
          ₹{" "}
          {Number(
            review?.totalPriceInfo.totalFareDetail.fC.BF
            // getBaseFare(
            //   review?.tripInfos[0].totalPriceList[0].fd,
            //   review?.searchQuery.paxInfo
            // )
          ).toFixed(2)}
        </Col>
        <Col
          xs={6}
          md={6}
          lg={6}
          style={{
            fontSize: 15,
            fontWeight: "bold",
          }}
        >
          Total Tax Fare
        </Col>
        <Col
          xs={6}
          md={6}
          lg={6}
          style={{
            justifyContent: "flex-end",
            display: "flex",
            fontSize: 15,
            fontWeight: "bold",
          }}
        >
          ₹{" "}
          {parseFloat(
            // getTotalTax(
            userMarkUp + review?.totalPriceInfo.totalFareDetail.fC.TAF
            // )
          ).toFixed(2)}
        </Col>
        <Col
          xs={6}
          md={6}
          lg={6}
          style={{
            fontSize: 15,
            fontWeight: "bold",
          }}
        >
          Handling Charge
        </Col>
        <Col
          xs={6}
          md={6}
          lg={6}
          style={{
            justifyContent: "flex-end",
            display: "flex",
            fontSize: 15,
            fontWeight: "bold",
          }}
        >
          ₹ {parseFloat(adminMarkup).toFixed(2)}
        </Col>

        <Col
          xs={6}
          md={6}
          lg={6}
          style={{
            fontSize: 15,
            fontWeight: "bold",
          }}
        >
          SSR Amount
        </Col>
        <Col
          xs={6}
          md={6}
          lg={6}
          style={{
            justifyContent: "flex-end",
            display: "flex",
            fontSize: 15,
            fontWeight: "bold",
          }}
        >
          ₹ {Number(calculateSSRAmount(values?.pax?.onward)).toFixed(2)}
        </Col>
      </Row>
      <Row>
        <div
          style={{
            width: "100%",
            float: "left",
            marginTop: "11px",
          }}
        >
          <div
            className="text-primary"
            style={{ borderBottom: "1px solid" }}
          ></div>
        </div>
      </Row>
      <Row
        className="bg-primary text-white"
        style={{ marginTop: 5, marginLeft: 1, marginRight: 1 }}
      >
        <Col
          xs={6}
          md={6}
          lg={6}
          style={{
            fontSize: 15,
            fontWeight: "bold",
          }}
        >
          Total Amount
        </Col>
        <Col
          xs={6}
          md={6}
          lg={6}
          style={{
            justifyContent: "flex-end",
            display: "flex",
            fontSize: 15,
            fontWeight: "bold",
          }}
        >
          ₹{" "}
          {Number(
            // totalFareHandler(
            review?.totalPriceInfo.totalFareDetail.fC.TF +
              userMarkUp +
              adminMarkup +
              calculateSSRAmount(values?.pax?.onward)
          ).toFixed(2)}
        </Col>
      </Row>
      <Row className="text-black">
        <Col
          xs={6}
          md={6}
          lg={6}
          style={{
            fontSize: 15,
            fontWeight: "bold",
          }}
        >
          Discount
        </Col>
        <Col
          xs={6}
          md={6}
          lg={6}
          style={{
            justifyContent: "flex-end",
            display: "flex",
            fontSize: 15,
            fontWeight: "bold",
          }}
        >
          ₹ -
          {Number(review?.totalPriceInfo.totalFareDetail?.afC?.NCM?.OT).toFixed(
            2
          )}
        </Col>
      </Row>
      <Row className="text-black">
        <Col
          xs={6}
          md={6}
          lg={6}
          style={{
            fontSize: 15,
            fontWeight: "bold",
          }}
        >
          TDS Amount
        </Col>
        <Col
          xs={6}
          md={6}
          lg={6}
          style={{
            justifyContent: "flex-end",
            display: "flex",
            fontSize: 15,
            fontWeight: "bold",
          }}
        >
          ₹ +
          {Math.abs(
            review?.totalPriceInfo.totalFareDetail?.afC?.NCM?.TDS
          ).toFixed(2)}
        </Col>
      </Row>
      <Row
        className="text-black"
        style={{
          backgroundColor: "gray",
          marginTop: 5,
          marginLeft: 1,
          marginRight: 1,
        }}
      >
        <Col
          xs={6}
          md={6}
          lg={6}
          style={{
            fontSize: 15,
            fontWeight: "bold",
          }}
        >
          Net Amount
        </Col>
        <Col
          xs={6}
          md={6}
          lg={6}
          style={{
            justifyContent: "flex-end",
            display: "flex",
            fontSize: 15,
            fontWeight: "bold",
          }}
        >
          ₹{" "}
          {Number(
            // totalFareHandler(
            review?.totalPriceInfo.totalFareDetail.fC.NF +
              adminMarkup +
              calculateSSRAmount(values?.pax?.onward)
          ).toFixed(2)}
        </Col>
      </Row>
    </div>
  );
}
